import { Injectable, Compiler, Injector, Type, NgModuleFactory, Inject, createNgModule, NgModuleRef } from '@angular/core';
import { formComponentMapOptions } from '~/front-models/form-component-map';
import { LAZY_WIDGETS } from './tokens';

@Injectable()
export class LazyLoaderService {

  constructor(
    private injector: Injector,
    private compiler: Compiler,
    @Inject(LAZY_WIDGETS) private lazyWidgets: { [key: string]: () => Promise<NgModuleFactory<any> | Type<any>> }
  ) { }

  async load(name: string): Promise<NgModuleRef<any> | undefined> {
    if (!this.lazyWidgets || !this.lazyWidgets[name] || typeof this.lazyWidgets[name] !== 'function') {
      console.warn(`LazyLoaderService: No lazy widget loader found for "${name}"`);
      return;
    }

    const ngModuleOrNgModuleFactory = await this.lazyWidgets[name]();

    let moduleRef: NgModuleRef<any>;

    if (ngModuleOrNgModuleFactory instanceof NgModuleFactory) {
      moduleRef = ngModuleOrNgModuleFactory.create(this.injector);
    } else if (typeof createNgModule === 'function') {
      moduleRef = createNgModule(ngModuleOrNgModuleFactory as Type<any>, this.injector);
    } else {
      const moduleFactory = await this.compiler.compileModuleAsync(ngModuleOrNgModuleFactory);
      moduleRef = moduleFactory.create(this.injector);
    }

    // In legacy ViewEngine (pre-Ivy), resolving component factory was used to register entryComponents.
    // In modern Angular (Ivy / Angular 14+ / 22+), components are resolved directly by Type and componentFactoryResolver is removed.
    const resolver = (moduleRef as any)?.componentFactoryResolver;
    if (resolver && typeof resolver.resolveComponentFactory === 'function' && formComponentMapOptions && formComponentMapOptions[name]) {
      resolver.resolveComponentFactory(formComponentMapOptions[name]);
    }

    return moduleRef;
  }
}
